export default __webpack_public_path__ + "static/media/new popup dec 2024.1464433f.svg";